<p-toast
  key="validation-error-summary"
  position="top-right"
  role="status"
  aria-live="assertive"
  aria-atomic="true"
  (onClose)="handleToastClose($event)"
>
  <ng-template let-message pTemplate="message">
    <div class="validation-toast-content">
      <div class="validation-toast-summary">{{ message.summary }}</div>
      <div class="validation-toast-detail">{{ message.detail }}</div>

      @if (detailsExpanded()) {
        <div class="validation-toast-hint">Clicca sui campi per visualizzarli</div>
      }

      <button
        type="button"
        class="details-toggle"
        [attr.aria-expanded]="detailsExpanded()"
        aria-controls="validation-error-details"
        (click)="toggleDetails()"
      >
        {{ detailsExpanded() ? 'Nascondi dettagli' : 'Mostra dettagli' }}
      </button>

      @if (detailsExpanded()) {
        <div id="validation-error-details" class="validation-toast-errors">
          @for (section of activeSections(); track section.title) {
            <section class="summary-section">
              <h3>{{ section.title }}</h3>
              <ul>
                @for (error of section.errors; track error.field) {
                  <li>
                    <button type="button" class="error-link" (click)="selectError(error.fieldId)">
                      {{ error.field }}
                    </button>
                    @if (error.message) {
                      <span class="error-message">{{ error.message }}</span>
                    }
                  </li>
                }
              </ul>
            </section>
          }
        </div>
      }
    </div>
  </ng-template>
</p-toast>